import React from 'react'
import "./Our_Services_card.css"

function Our_Services_card({imgSrc,iconSrc, heading,description}) {
    return (
        <>
            <section className='Our_Services_card'>
                <div className="img_icon_holder">
                    <div className='img_holder'>
                        <img src={imgSrc} alt="Service" className='services_img' />
                    </div>
                    <div className='icon_holder'>
                        <img src={iconSrc} alt="Icon" className='icon_img' />
                    </div>
                </div>
                <div className="text_holder">
                    <h4>{heading}</h4>
                    <p>{description}</p>
                </div>
            </section>
        </>
    )
}

export default Our_Services_card